module.exports = __webpack_public_path__ + "img/synthesisScore.fe708247.png";